export const inViewport = (entries: IntersectionObserverEntry[], toggleClass: string, isEntryIntersectingCallBack: (entry: IntersectionObserverEntry) => any) => {
  entries.forEach(entry => {
    entry.target.classList.toggle(toggleClass, entry.isIntersecting);
    isEntryIntersectingCallBack(entry);
  });
};
